<div [formGroup]="parentFormGroup">
  @if (file) {
    <span class="file-name">Selected file: {{file.name}}</span>
  }
  <button type="button" mat-raised-button color="primary" (click)="openInput($event)"> {{!!file ? 'Change file' :
  'Select File to Upload'}} </button>
  <input class="hidden" #fileInput type="file" accept=".png,.jpg" (change)="onFileChange($event.target.files)" formControlName="fileInput">
  <input class="hidden" formControlName="fileName">
  <input class="hidden" formControlName="file">
</div>
